import React, { useState, useContext } from "react";
import { message, Popconfirm } from 'antd';

import { MailboxContext } from '../context/Mailbox';
import PasswordInput, { passwordRules } from './PasswordInput';

// Change the password of a mailbox, or delete (disable) it.
// onClose( changed ) closes the modal; changed = true reloads the list.
const ModalEditMailbox = ({ mailbox, onClose }) => {

	const { updatePassword } = useContext( MailboxContext );
	const email = mailbox.email;

	const [ newPassword, setNewPassword ] 		= useState( '' );
	const [ repeatPassword, setRepeatPassword ] = useState( '' );
	const [ errors, setErrors ] 				= useState( {} );
	const [ saving, setSaving ] 				= useState( false );

	// a suggested password fills both fields
	const handleSuggest = ( password ) => {
		setRepeatPassword( password );
	};

	const handleSave = async ( e ) => {
		e.preventDefault();
		const next = {};
		if( !passwordRules.every( r => r.test( newPassword ) ) )
			next.password = 'Choose a password that meets all the rules below.';
		else if( newPassword.length > 100 )
			next.password = 'Your password can be at most 100 characters long.';
		if( repeatPassword !== newPassword )
			next.repeat = 'The two passwords are different.';
		setErrors( next );
		if( Object.keys( next ).length )
			return;

		setSaving( true );
		const rep = await updatePassword( { email, password: newPassword } );
		setSaving( false );
		if( rep ){
			message.success( 'Password changed for ' + email + '.' );
			onClose( true );
		}
	};

	const handleDelete = async () => {
		setSaving( true );
		const rep = await updatePassword( { email, enabled: 0 } );
		setSaving( false );
		if( rep ){
			message.success( email + ' has been deleted.' );
			onClose( true );
		}
	};

	return (
		<div className="dm-site dm-edit">
			<h2 className="dm-edit-title">Edit mailbox</h2>
			<p className="dm-edit-email">{ email }</p>

			<form onSubmit={ handleSave } noValidate>
				<h3 className="dm-edit-section">Change password</h3>
				<div className="dm-field">
					<label htmlFor="dm-edit-password">New password</label>
					<PasswordInput
						id				= "dm-edit-password"
						className		= "dm-input"
						value			= { newPassword }
						onChange		= { setNewPassword }
						onSuggest		= { handleSuggest }
						placeholder		= "New password"
						autoComplete	= "new-password"
						invalid			= { !!errors.password }
						describedBy		= { errors.password ? 'dm-edit-password-error' : undefined }
						suggest
						showRules
					/>
					{ errors.password && <p className="dm-error" id="dm-edit-password-error">{ errors.password }</p> }
				</div>
				<div className="dm-field">
					<label htmlFor="dm-edit-repeat">Repeat the new password</label>
					<PasswordInput
						id				= "dm-edit-repeat"
						className		= "dm-input"
						value			= { repeatPassword }
						onChange		= { setRepeatPassword }
						placeholder		= "Repeat the new password"
						autoComplete	= "new-password"
						invalid			= { !!errors.repeat }
						describedBy		= { errors.repeat ? 'dm-edit-repeat-error' : undefined }
					/>
					{ errors.repeat && <p className="dm-error" id="dm-edit-repeat-error">{ errors.repeat }</p> }
				</div>
				<p className="dm-help">After changing it, update the password in any email app that uses this mailbox.</p>

				<div className="dm-edit-actions">
					<Popconfirm
						title		= { 'Delete ' + email + '?' }
						description	= "It will stop receiving email and you won't be able to log in to it."
						onConfirm	= { handleDelete }
						okText		= "Delete"
						okButtonProps = {{ danger: true }}
						cancelText	= "Cancel"
					>
						<button type="button" className="dm-btn dm-btn-danger" disabled={ saving }>Delete mailbox</button>
					</Popconfirm>
					<span className="dm-edit-spacer" />
					<button type="button" className="dm-btn dm-btn-outline" onClick={ () => onClose( false ) }>Cancel</button>
					<button type="submit" className="dm-btn dm-btn-primary" disabled={ saving }>{ saving ? 'Saving…' : 'Save password' }</button>
				</div>
			</form>
		</div>
	);
};

export default ModalEditMailbox;
